import React from "react";
import ConvocatoriaPlantillasView from "./pages/ConvocatoriaPlantillasView.jsx";

export default function ConvocatoriaPlantillas() {
  return <ConvocatoriaPlantillasView />;
}
